/**
 * Identidade da plataforma. Altere aqui para renomear o produto.
 * A identidade de cada empresa (nome, logotipo) pertence ao tenant e fica no banco.
 */
export const BRAND = {
  name: 'Zuri Finance',
  shortName: 'Zuri',
  tagline: 'Gestão financeira para empresas',
  platformAreaName: 'Zuri Finance · Plataforma',
  supportEmail: 'suporte@zuri.finance',
  locale: 'pt-BR',
  currency: 'BRL',
  defaultTimeZone: 'America/Sao_Paulo',
} as const;
